<!--
 * @Description: 相关性热图
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
      <div style="display: flex; align-items: center">
        <span
          class="bi-tmpl-detail__right__cmpt__title"
          style="margin: 0 16px 0 0"
        >
          是否在BI中展示附件
        </span>
        <BaseRadio
          @click="onChange('1')"
          value="1"
          :model-value="curItem.value"
        >
          是
        </BaseRadio>
        <BaseRadio
          @click="onChange('0')"
          value="0"
          :model-value="curItem.value"
        >
          否
        </BaseRadio>
      </div>
    </div>
    <Carousel ref="carouselRef" :itemHeight="675" :itemWidth="420 + 56">
      <div class="xrk-card" style="width: 420px; height: 660px">
        <div
          :style="{
            width: '100%',
            height: '660px',
            'border-radius': '2px',
            position: 'absolute',
            padding: '0 20px',
            top: '0',
            left: '0'
          }"
        >
          <component
            v-if="titleCmpt"
            :is="titleCmpt"
            style="
              width: 1200px;
              transform: scale(0.33);
              transform-origin: 0 center;
            "
            v-bind="{
              innerText: '相关性热图',
              enInnerText: 'correlation heatmap & correlation clustermap'
            }"
          />
          <div
            style="
              transform-origin: 0 15px;
              padding: 18px 24px;
              border: 2px dashed rgb(167, 167, 167);
              transform: translateY(-8px) scale(0.5);
              width: 750px;
              transform-origin: 0 0;
            "
          >
            <span>
              相关性热图是一种二维可视化图表，用来分析不同变量之间的相关性和变化趋势。每个数据点的颜色表示该变量之间的相关性强度，常用于探索数据集中的模式和关系。相比于简单的散点图，相关性热图能够显示更加复杂的数据结构，为数据分析提供更全面的视角和更深入的理解。
            </span>
          </div>
          <component
            class="subTitleCmpt-16"
            v-if="subTitleCmpt"
            :is="subTitleCmpt"
            style="height: 32px"
            v-bind="{
              innerText: '热图-系数（r）'
            }"
          />
          <div style="margin: 0 auto; width: 350px">
            <PcModuleHeatmapOnCartesian_1
              :color-list="colorList"
            ></PcModuleHeatmapOnCartesian_1>
          </div>
          <div
            style="
              transform-origin: 0 0;
              padding: 18px 24px;
              border: 2px dashed rgb(167, 167, 167);
              transform: scale(0.5);
              width: 750px;
            "
          >
            斯皮尔曼相关系数的数值代表两个变量之间的相关强度和方向。范围是从-1到+1。如果相关系数为正，表示当一个变量增加时，另一个变量也倾向于增加。如果相关系数为负，表示当一个变量增加时，另一个变量倾向于减少。相关系数的绝对值越大，表示两个变量之间的相关性越强。当相关系数的绝对值接近1时，表示两个变量之间存在完全的单调关系；当相关系数的绝对值接近0时，表示两个变量之间几乎没有任何相关性。
          </div>
          <component
            style="width: 80px; height: 40px"
            v-if="pageNoCmpt"
            :is="pageNoCmpt"
          />
        </div>
      </div>
      <div class="xrk-card" style="width: 420px; height: 660px">
        <div
          :style="{
            width: '100%',
            height: '660px',
            'border-radius': '2px',
            position: 'absolute',
            top: '0',
            left: '0',
            padding: '10px 20px'
          }"
        >
          <component
            v-if="subTitleCmpt"
            :is="subTitleCmpt"
            style="height: 32px"
            v-bind="{
              innerText: '热图-P值'
            }"
          />
          <div style="margin: 0 auto; width: 350px">
            <PcModuleHeatmapOnCartesian_2
              :color-list="colorList"
            ></PcModuleHeatmapOnCartesian_2>
          </div>
          <div
            style="
              transform-origin: 0 0;
              padding: 18px 24px;
              border: 2px dashed rgb(167, 167, 167);
              transform: scale(0.5);
              width: 750px;
            "
          >
            {{
              `如果 P 值很小（通常认为小于 0.05 或 0.01），这意味着两个变量之间的相关性是显著的，即它们之间存在一定的关联。这种关联可能是正相关或负相关，具体取决于斯皮尔曼相关系数的值。如果 P 值大于 0.05，这意味着两个变量之间的相关性不显著，即它们之间没有明显的关联。这可能是因为数据量不足、样本偏差或其他原因导致的结果。`
            }}
          </div>
          <component
            style="width: 80px; height: 40px"
            v-if="pageNoCmpt"
            pageNo="02"
            :is="pageNoCmpt"
          />
        </div>
      </div>
      <div class="xrk-card" style="width: 420px; height: 660px">
        <div
          :style="{
            width: '100%',
            height: '660px',
            'border-radius': '2px',
            position: 'absolute',
            top: '0',
            left: '0',
            padding: '18px 20px'
          }"
        >
          <component
            v-if="subTitleCmpt"
            :is="subTitleCmpt"
            style="height: 32px"
            v-bind="{
              innerText: '附件'
            }"
          />
          <div style="margin: 0 auto; width: 380px">
            <PcModuleHeatmapOnCartesian_3></PcModuleHeatmapOnCartesian_3>
          </div>
          <component
            style="width: 80px; height: 40px"
            v-if="pageNoCmpt"
            pageNo="03"
            :is="pageNoCmpt"
          />
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import {
  PcModuleHeatmapOnCartesian_1,
  PcModuleHeatmapOnCartesian_2,
  PcModuleHeatmapOnCartesian_3
} from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-heatmap-on-cartesian';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const { curItem, onChange, titleCmpt, pageNoCmpt, subTitleCmpt, state } =
  useDetailCmpt({});

const colorList = ref(
  state.value.menuValue.get('101').value['101_1'].value.split(',')
);
</script>
<style lang="scss" scope>
.subTitleCmpt-16 {
  // position: absolute;
  width: 378px;
  top: 152px;
  left: 20px;
}
</style>
